import { Box, Typography } from "@mui/material";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";
import { colors } from "@components/ui/colors";
import { PrimaryButton } from "@components/Buttons/PrimaryButton";

interface EmptyNumbersStateProps {
    onClearSearch?: () => void;
}

export const EmptyNumbersState = ({ onClearSearch }: EmptyNumbersStateProps) => {
    return (
        <Box
            sx={{
                border: `1.5px dashed ${colors.gray[100]}`,
                borderRadius: "16px",
                py: 5,
                px: 2.5,
                textAlign: "center",
                bgcolor: colors.gray[50],
            }}
        >
            <Box
                sx={{
                    width: 46,
                    height: 46,
                    borderRadius: "14px",
                    mx: "auto",
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: colors.orange[50],
                    color: colors.orange[500],
                }}
            >
                <SearchOffRoundedIcon sx={{ fontSize: 24 }} />
            </Box>

            <Typography
                sx={{
                    fontSize: 15,
                    fontWeight: 800,
                    color: colors.gray[500],
                    mb: 0.5,
                }}
            >
                No numbers found
            </Typography>

            <Typography
                sx={{
                    fontSize: 13,
                    color: colors.gray[400],
                    fontWeight: 500,
                    lineHeight: 1.6,
                    maxWidth: 320,
                    mx: "auto",
                    mb: onClearSearch ? 2 : 0,
                }}
            >
                We couldn’t find available numbers for this area code. Try another code
                or clear your search.
            </Typography>

            {onClearSearch && (
                <PrimaryButton
                    variant="outlined"
                    fullWidth={false}
                    onClick={onClearSearch}
                    sx={{
                        borderRadius: "10px",
                        px: 2.5,
                        py: 0.8,
                        fontSize: 13,
                    }}
                >
                    Clear search
                </PrimaryButton>
            )}
        </Box>
    );
};